import React from "react";
import board from "../../data/board.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faFileAlt, faBuilding } from "@fortawesome/free-solid-svg-icons";

const Intro = ({ t }) => {
  return (
    <div className="transparency-intro-block mb-5">
      {/* Intro Institution banner */}
      <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5 bg-white mb-4">
        <div className="d-flex align-items-center mb-3">
          <FontAwesomeIcon icon={faBuilding} className="text-warning fs-3 me-3" />
          <h4 className="subpage-title mb-0">Associazione Nuova Orchestra Busoni</h4>
        </div>
        <div className="subpage-text-content">
          <p className="mb-0">{t("transparency.intro_1")}</p>
        </div>
      </div>

      {/* Governing body card */}
      <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5 bg-white mb-4">
        <div className="d-flex align-items-center mb-4 pb-2 border-bottom">
          <FontAwesomeIcon icon={faUsers} className="text-warning fs-4 me-3" />
          <h4 className="section-subheading mb-0 text-capitalize">
            {t("transparency.governing_body")}
          </h4>
        </div>

        <div className="row g-3">
          {board.map((member, index) => (
            <div key={index} className="col-12 col-md-6">
              <div className="p-3 rounded-3 bg-light d-flex justify-content-between align-items-center">
                <span className="small text-muted text-uppercase fw-semibold">
                  {t(member.titleKey)}
                </span>
                <span className="fw-bold text-dark">{member.name}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 pt-3 border-top subpage-text-content small text-muted">
          <p className="mb-0">{t("transparency.intro_2")}</p>
        </div>
      </div>

      {/* Obligations & L. 124/2017 banner */}
      <div className="card border-0 shadow-sm rounded-4 p-4 bg-light mb-4">
        <div className="d-flex align-items-center mb-2">
          <FontAwesomeIcon icon={faFileAlt} className="text-secondary fs-4 me-3" />
          <h5 className="section-subheading mb-0 text-capitalize">
            {t("transparency.advertising_obligations")}
          </h5>
        </div>
        <p className="mb-0 text-muted small">{t("transparency.intro_3")}</p>
      </div>
    </div>
  );
};

export default Intro;
